/**************************************************
 * Nombre:       Formulario_Lista_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircle,
    BadgeOutlined,
    Flag,
    Mail,
    MapsHomeWorkOutlined,
    SignpostOutlined,
    SmartphoneOutlined,
    CakeOutlined
} from "@mui/icons-material";

import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../App";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";

const Formulario_Direccion = ({...props}) => {



    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos personales</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircle} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}/>
                </Grid>



                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificación'} dato={'cc'} {...props} type={'number'} />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={SmartphoneOutlined} nombre={'Celular'} dato={'celular'} {...props}
                                  requerido={'Campo requerido'} type={'phone'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Mail} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'Campo requerido'} type={'email'}
                    />
                </Grid>

                <Grid container size={6}>
                    <Typography sx={{fontSize: 14, fontWeight: 300, lineHeight: 1.2}}>Dejanos darte una sorpresa</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha Icono={CakeOutlined} nombre={'Cumpleaños (opcional)'} dato={'fechaCumple'}{...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos de entrega</Typography>
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={MapsHomeWorkOutlined} nombre={'Barrio o Localidad'}
                                  dato={'barrio'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Dirección'} dato={'direccion'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Indicaciones adiciónales'} dato={'indicaciones'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoSelect Icono={Flag} nombre={'¿Tu direccion queda mas cerca de?'} dato={'localCercano'} {...props}
                    opciones={['Puenes', 'Parque 20 de Julio', 'Carrera 11']}  requerido={'Campo requerido'}
                    />
                </Grid>



                <Grid container size={12} sx={{px: 1}}>
                    <Typography sx={{
                        fontSize: 12,
                        fontWeight: 400,
                        lineHeight: 1.1
                    }}>{`**Al realizar el pedido apruebas nuestra política de tratamiento de datos y de compras.`}</Typography>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Direccion